import { render, staticRenderFns } from "./TrainingBreadcrumb.vue?vue&type=template&id=52729f4c&scoped=true&"
import script from "./TrainingBreadcrumb.vue?vue&type=script&lang=ts&"
export * from "./TrainingBreadcrumb.vue?vue&type=script&lang=ts&"
import style0 from "./TrainingBreadcrumb.vue?vue&type=style&index=0&id=52729f4c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52729f4c",
  null
  
)

export default component.exports